<template>
  <div>
    <AuthorizationPage @auth:succeed="submit" />
  </div>
</template>

<script>
import api from "@/api";
import config from "@/config";
import AuthorizationPage from "@/components/Authorization.vue";
export default {
  components: { AuthorizationPage },
  data() {
    return {
      loading: true,
      updateData: {},
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
    profile() {
      return this.$store.state.profile;
    },
    userid() {
      return this.$store.state.query.userid;
    },
  },
  watch: {},
  mounted() {
    //   this.setup()
  },
  methods: {
    async setup() {},
    async submit() {
      this.$router.push(`/selectAddressNoRegis?userid=${this.userid}`);
    },
  },
};
</script>

<style></style>
